export default "__VITE_ASSET__MJmjolk9__"